import axios from "axios";
import { BACKEND_ROOT_URL } from "../api";
import { getCookie } from "../hooks/useCookies";

const api = axios.create({
  baseURL: BACKEND_ROOT_URL,
  timeout: 60000, // 30 seconds
  headers: {
    "Content-Type": "application/json",
  },
});

// Add an interceptor to automatically include the Authorization token in every request
api.interceptors.request.use(
  (config) => {
    const token = getCookie("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ✅ Response interceptor: Handle {"message": "Unauthorized"}
api.interceptors.response.use(
  (response) => {
    // Optional: you can check response.data here as well if needed
    return response;
  },
  (error) => {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message === "Unauthorized"
    ) {
      console.warn("🔒 Unauthorized access detected");
      window.location.href = "/signinoptions";
    }

    return Promise.reject(error); // Let the caller handle other errors
  }
);

export default api;
